<template>
  <section class="flex justify-center py-48 whitespace-nowrap">
    <h1>Cohorts page coming soon...</h1>
  </section>
</template>
